import {defineStore} from "pinia";
import {Ref, ref} from "vue";
import {IFilter} from "@/types/main";
import {personalService} from "@/features/personal/personal.service";
import {useAlert} from "@/utils/alert";

const {show} = useAlert()
export const usePersonalStore = defineStore("personal", () => {
    const commonFilter = ref<IFilter>({
        q: '',
        date_from: '',
        date_to: '',
        time_from: '',
        time_to: '',
        shift_id: 0,
        account: 0,
        outgoing: null,
        fuzzy: true,
        fuzzy_threshold: 0.3,
        page: 1,
        page_size: 100,
        include_photo_base64: false
    })

    async function getPersonalChats(
        loading: Ref<boolean>,
        chat_id: number,
        account_id: number,
        cl: any
    ) {
        loading.value = true
        let newFilter = {...commonFilter.value}
        newFilter.account = account_id;
        await personalService.getChatMessages(chat_id, newFilter)
            .then((result) => {
                cl(result)
            }).catch(error => {
                show(error, "error");
            }).finally(() => {
                loading.value = false
            })
    }


    return {commonFilter, getPersonalChats};
})